const user_detail = {
  user_info: {},
  L1Approver: "",
  code: "",
};

const user = {
  businessPhones: 0,
  approval_screens: [],
  displayName: "",
  givenName: "",
  id: "",
  jobTitle: "",
  mail: "",
  mobilePhone: "",
  officeLocation: "",
  preferredLanguage: "",
  surname: "",
  userPrincipalName: "",
  isAuth: false,
  theme: "light",
  username: "",
  token: "",
  error: null,
  role: null,
  errorCode: null,
  ticketPortal: {},
  alertInfo: {
    message: "",
    open: false,
    severity: "success",
    closeFlag: true,
  },
  screen: {
    isSidenavBarExpanded: false,
  },
};

const source = {
  isAnyRecordDeleted: false,
  fulactualdata: [],
  actualData: [],
  get_recommendation_status: "",
  get_recommendation_error_message: { status: false, message: "" },
  get_recommendation_for_all_rows: false,
  get_recommendation_all_modal_data: [],
  is_file_uploaded: false,
  has_awaiting_data: false,
  data: [],
  data_logs: [],
  screens: [],
  checked_rows_count: 0,
  current_bussines_unit: "",
  temp_edit_modal_column_list: [],
  temp_table_header_column_list: [],
  current_source: "",
  current_source_logs: "",
  current_source_label: "",
  current_usecase: "",
  current_iqvia_source_file_id: "",
  current_nielsen_source_file_id: "",
  isNewDropdownValue: false,
  isNewDropdownLocalValue: false,
  isNewDropdownMappedValue: false,
  isNewPowerBrandDropdownValue: false,
  isNewRBFilteredBrandDropdownValue: false,
  isNewMappingType_logs: [],
  isNewPowerBrand_logs: [],
  isNewRBFilteredBrand_logs: [],
  isNewLocalValue_logs: [],
  isNewMappedValue_logs: [],
  current_dimension: {},
  dimensions_list: [],
  current_target_gold_layer: "",
  current_target_gold_layer_logs: "",
  current_country: "",
  current_country_logs: "",
  current_country_code: "",
  current_country_code_logs: "",
  current_mapping_type: "",
  current_mapping_type_list: [],
  current_cmu: "",
  current_category: "",
  current_ssfFileId: "",
  current_ssfFileId_logs: "",
  current_filter_value: "",
  current_template_filter_value: "",
  current_template_ssfFileId: "",
  current_table_name: "",
  is_initial: true,
  is_table_loading: true,
  is_initial_logs: false,
  is_table_loading_logs: false,
  searchValue: "",
  any_row_isEditing: false,
  isFileUploaded: false,
  isNewDataInserted: false,
  current_bussines_unit_list: [],
  current_iqvia_source_file_id_list: [],
  current_nielsen_source_file_id_list: [],
  current_mapped_source: [],
  current_mapped_source_logs: [],
  current_target_gold_layer_list: [],
  current_usecase_list: [],
  current_target_gold_layer_list_logs: [],
  current_mapped_country: [],
  current_mapped_country_logs: [],
  master_table_countries: [],
  current_ssf_file_id: [],
  current_ssf_file_id_logs: [],
  current_template_ssf_file_id: [],
  current_category_data: [],
  current_mapped_data: [],
  current_mapped_data_main: [],
  modified_mapped_data: [],
  current_filters: [],
  appliedFilters: [],
  download_sample_file: [],
  filtered_Rows: [],
  current_columns: [],
  recommendedModel: [],
  approvalData: [],
  approvalTable_Header: [],
  historyData: [],
  historyTable_Header: [],
  current_usecase_value: "",
};

const admin = {
  documents_list: [],
  current_document: "",
  usecase_metadata: {},
  admin_metadata: {},
};

export const stateData = {
  user,
  user_detail,
  source,
  admin,
};
